import { render, staticRenderFns } from "./CompanyNewModal.vue?vue&type=template&id=4df995ae"
import script from "./CompanyNewModal.vue?vue&type=script&lang=js"
export * from "./CompanyNewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df995ae')) {
      api.createRecord('4df995ae', component.options)
    } else {
      api.reload('4df995ae', component.options)
    }
    module.hot.accept("./CompanyNewModal.vue?vue&type=template&id=4df995ae", function () {
      api.rerender('4df995ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/CompanyNewModal.vue"
export default component.exports